export default "__VITE_ASSET__C5eeT7DD__"